import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AreaType } from 'app/com/ibm/tw/commons/enums/global/area.type';
import { BaseComponent } from 'app/com/ibm/tw/commons/mvc/base.component';
import { CcmotlginFaqViewForm } from 'app/pagecode/cot/ccmotlgin/faq/ccmotlgin.faq.viewform';
import { AxthenticationService } from 'app/services/axthentication.service';
import { TxnService } from 'app/services/txn.service';
import { Popup } from 'ui-components/popup';

@Component({
    standalone: false,
    selector: 'page-footer',
    templateUrl: './page.footer.component.html'
})
export class PageFooterComponent extends BaseComponent implements OnInit {

    // {{'瀏覽器建議'|i18n:'common00001618':null}}
    msgTitle1: string;

    // {{'常見問題'|i18n:'common00002587':null}}<
    msgTitle2: string;

    // {{'法定公開揭露事項'|i18n:'common00002282':null}}
    msgTitle3: string;

    // {{'金融友善服務'|i18n:'common00001973':null}}<
    msgTitle4: string;

    /** 是否為交易 */
    @Input() isTask: boolean = false;

    /** 是否顯示可以其它選項 */
    @Input() showDetail: boolean = true;

    /**
     * 是否顯示FAQ Popup
     */
    // showFaqPopup: boolean = false;

    /**
     * FAQ Popup
     */
    faqPopupViewForm: CcmotlginFaqViewForm = new CcmotlginFaqViewForm();

    constructor(
        private axthenticationService: AxthenticationService,
        private router: Router,
        public txnService: TxnService) {
        super(txnService);
    }

    ngOnInit() {
        // console.log('CcmhmannoMainFooterComponent init...');
        this.doChangeLang();
    }

    /**
     * 變更多國語系.
     */
    public doChangeLang() {
        this.msgTitle1 = this.txnService.transform('瀏覽器建議', 'common00001618', null);
        this.msgTitle2 = this.txnService.transform('常見問題', 'common00002587', null);
        this.msgTitle3 = this.txnService.transform('法定公開揭露事項', 'common00002282', null);
        this.msgTitle4 = this.txnService.transform('金融友善服務', 'common00001973', null);
    }

    /**
     * 開啟常見問題對話框
     * @param event
     */
    openFaqPopup(event) {
        // this.showFaqPopup = true;
        let area = this.txnService.getShareService().currentArea;
        if (area === undefined || area === AreaType.GLOBAL) {
            area = AreaType.TW;
        }

        console.log('openFaqPopup...' + area + ',isLoggedIn=' + this.axthenticationService.isLoggedIn + ',' + this.router.url);
        console.log('window.location.href===' + window.location.href);

        let url = window.location.href;
        if (url.indexOf('/main/') > -1) {
            this.router.navigate(
                ['/main', {
                    outlets: {
                        subContent: ['subPageCode', 'faq', area.toLowerCase()]
                    }
                }],
            );
        } else {
            this.router.navigate(
                ['/cot', {
                    outlets: {
                        homeContent: ['cotSubPageCode', 'faq', area.toLowerCase()]
                    }
                }],
            );
        }

    }


}


